const Advice = require('../../../../utils/advice');
const BaseView = require('../abstract-element-options');

module.exports = BaseView.extend({
  template: require('./template.hbs'),

  initialize: function (options) {
    this.selection = options.selection;
    this.assets = _.chain(this.getRestrictions('images'))
      .pluck('list')
      .flatten()
      .value();
    this.assets = this.assets.map(source => ({ source, thumbnail: source }));
    this.folders = this.getRestrictions('images')?.[0]?.library_folder?.map((folder) =>
      typeof folder === 'number' || folder === 'all'
        ? {
            resourceId: folder,
            folderId: folder
          }
        : folder
    );
    const basicRestrictions = this.getRestrictions('basic');
    this.canReplace = basicRestrictions && basicRestrictions[0] && basicRestrictions[0].image;

    if (!this.getRestrictions('opacity').length) {
      Advice.messages = Advice.messages.filter(i => !['background-color-add'].includes(i.id));
    }

    BaseView.prototype.initialize.call(this, options);
  },

  render: function () {
    if (INKIVE.RestrictionsFacade.isRestrictedProject()) {
      this.$el.html(this.template({}));
      this.initReplacementPanel({
        assets: this.assets,
        colors: this.colors?.length > 0 && [{ palette: [...this.colors] }],
        folders: this.folders
      }, 'image');
    } else {
      this.$el.addClass('show-images-tab');
    }
  },

  replaceItem: function (asset) {
    if (!asset.source) {
      return;
    }

    if (asset.action === 'color_replace') {
      INKIVE.DesignFacade.set('background', { color: asset.source });
      return;
    }
    const selectedElement = INKIVE.DesignFacade.getSelectedElements()[0];
    if (!selectedElement) {
      return;
    }

    INKIVE.DesignFacade.set('background', {
      source: {
        preload: true,
        url: asset.details.data.source || asset.source
      },
      keep_box_size: true,
      just_added: asset.details
    });
  }
});
